/* American Premium "Shop all vitamins": benefit chips filter the server-rendered card grid. Without this script every
   card stays visible and the chips stay hidden. Ingredient disclosures, motion pause and the menu come from ap-home.js. */
(() => {
  'use strict';
  const filter = document.querySelector('[data-collection-filter]');
  const grid = document.getElementById('collection-grid');
  if (!filter || !grid) return;
  const chips = [...filter.querySelectorAll('[data-filter]')];
  const count = filter.querySelector('[data-collection-count]');
  const reset = filter.querySelector('[data-collection-reset]');
  const cards = [...grid.querySelectorAll('.product-card')];

  const apply = chip => {
    const ids = chip.dataset.filter ? chip.dataset.filter.split(',').filter(Boolean) : null;
    chips.forEach(c => c.setAttribute('aria-pressed', String(c === chip)));
    let shown = 0;
    cards.forEach(card => {
      card.hidden = Boolean(ids && !ids.includes(card.dataset.product));
      if (!card.hidden) shown += 1;
    });
    count.textContent = ids ? `${chip.dataset.needName} · ${shown} ${shown === 1 ? count.dataset.one : count.dataset.many}` : count.dataset.allLabel;
    reset.hidden = !ids;
  };

  chips.forEach(chip => chip.addEventListener('click', () => apply(chip)));
  reset.addEventListener('click', () => { apply(chips[0]); chips[0].focus({preventScroll: true}); });
  chips.forEach(chip => { chip.disabled = false; });
  filter.setAttribute('aria-busy', 'false');
})();
